module.exports = __webpack_public_path__ + "img/CSC-logo_text-on-the-right-02(1).b7b5afe2.png";